import React, { Component } from 'react';

import LoadingDialog from '../../dialog/LoadingDialog';
import ErrorDialog from '../../dialog/ErrorDialog';
import icon_add from '../../resources/add.png';
import icon_coins from '../resources/coins.png';
import icon_wheeler from '../resources/wheeler.png';
import icon_address from '../resources/address.png';
import icon_phone from '../resources/phone.png';
import icon_barcode from '../../resources/barcode.png';
import icon_media from '../../resources/media.png';
import icon_category from '../../resources/category.png';
import icon_font from '../../resources/font.png';
import icon_lightbulb from '../../resources/lightbulb.png';
import gif_img from '../../resources/loading.gif';
import img_error from '../../resources/error.png';
import img_expand_more from '../../resources/baseline_expand_more.png';
import PriceFeeDialog from './PriceFeeDialog';
import DropdownSearch from '../../native/DropdownSearch';
import img_add_white from '../../resources/baseline_add_white.png';
import img_edit from '../../resources/baseline_edit.png';
import img_edit_black from '../../resources/baseline_edit_black.png';
import percent from '../../resources/percent.png';
import Switch from "react-switch";

var request = require('../../../utilities/NetworkRequest');
var view_util = require('../../../utilities/ViewUtil');
var str_util = require('../../../utilities/StringUtil');
var img_utils = require('../../../utilities/ImageUtil');

export default class WholesalerDialog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      is_main_loading : true,
      is_loading : false,
      is_error : false,
      error_message : '',
      body_error : {
        is_show : false,
        message : ''
      },
      product_fee_dialog : {
        is_show : false,
        data : null
      },
      wholesaler_type : {},
      status_wholesaler : {},
      type_wholesaler : {},
      payment : [],
      information : {},
      image : null,
      product_fee : [],
      category:{},
    }
  }

  componentDidMount() {
    let body = this.props.body;
    if (body === null) { body = {}; }
    request.onRequestData(1, '/show/detail_wholesaler', body, res_data => {
      // if (!this._isMounted) return;
      if (res_data.code === 1) {
        this.setState({
          information : {...res_data.result.information,presentase_lpi_fee:0,amount_lpi_fee:0,is_active:true},
          payment : res_data.result.payment,
          wholesaler_type : res_data.result.wholesaler_type,
          status_wholesaler : res_data.result.status_wholesaler,
          type_wholesaler : res_data.result.type_wholesaler,
          product_fee:res_data.result.price_fee ? res_data.result.price_fee : [],
          is_main_loading : false,
          switch:false,
          is_error : false
        });
      } else {
        this.setState({
          is_main_loading : false,
          is_error : true,
          error_message : res_data.message
        });
      }
    });

    request.onRequestData(7, '/grosirpintar/show/home', body, res_data => {
      if (res_data.code === 1) {
        let result = {
          data:[],
          selected:{}
        };

        for(let i of res_data.result){
          if(i.hasOwnProperty('categories')){
            for(let x of i.categories){
              result.data.push({
                key:x.id,
                label:x.text
              });
            };
            result.selected = {
              key:null,
              label:'Pilih Kategori'
            }
          };
        };

        this.setState({
              category : result
        });
        
      }
    });
  }

  getDetailWholesaler(){
    let body = this.props.body;
    if (body === null) { body = {}; }
    request.onRequestData(1, '/show/detail_wholesaler', body, res_data => {
      if (res_data.code === 1) {
        this.setState({
          information : {...res_data.result.information,presentase_lpi_fee:0,amount_lpi_fee:0,is_active:true},
          payment : res_data.result.payment,
          wholesaler_type : res_data.result.wholesaler_type,
          status_wholesaler : res_data.result.status_wholesaler,
          type_wholesaler : res_data.result.type_wholesaler,
          product_fee:res_data.result.price_fee ? res_data.result.price_fee : [],
          is_main_loading : false,
          is_error : false
        });
      } else {
        this.setState({
          is_main_loading : false,
          is_error : true,
          error_message : res_data.message
        });
      }
    });

    request.onRequestData(7, '/grosirpintar/show/home', body, res_data => {
      if (res_data.code === 1) {
        let result = {
          data:[],
          selected:{}
        };

        for(let i of res_data.result){
          if(i.hasOwnProperty('categories')){
            for(let x of i.categories){
              result.data.push({
                key:x.id,
                label:x.text
              });
            };
            result.selected = {
              key:null,
              label:'Pilih Kategori'
            }
          };
        };

        this.setState({
              category : result
        });
        
      }
    });
  }

  getNeedApprovalASMForReleaseLK() {
    return (
      <div className='wrapper_right_form_product normal_border_bottom'>
        {view_util.getSwitchView(this, 'is_approval', 'Harus approval ASM untuk release Bayar Nanti', '#43987b')}
      </div>
    );
  }
  getStatusJatuhTempoBN() {
    return (
      <div className='wrapper_right_form_product normal_border_bottom'>
        {view_util.getSwitchView(this, 'is_jatuh_tempo_extended_7_days', 'Jatuh Tempo Bayar Nanti H + 7', '#43987b')}
      </div>
    );
  }

  getProductFee() {
    return (
      <div className='wrapper_right_form_product normal_border_bottom'>
        {view_util.getButtonView(this, 'product_fee')}
      </div>
    );
  }

  getStatusLoyalty() {
    return (
      <div className='wrapper_right_form_product normal_border_bottom'>
        {view_util.getSwitchView(this, 'open_loyalty_mayora', 'Point Loyalty Mayora', '#43987b')}
      </div>
    );
  }

  getStatusActiveFee() {
    return (
      <div className='wrapper_right_form_product normal_border_bottom'>
        {view_util.getSwitchView(this, 'is_active', 'Aktif', '#43987b')}
      </div>
    );
  }

  getStatusWholesaler() {
    return (
      <div className='wrapper_right_form_product normal_border_bottom'>
        {view_util.getSwitchView(this, 'is_active', 'Tampilkan Grosir', '#43987b')}
        {view_util.getSwitchView(this, 'is_open', 'Izinkan Penambahan CB', '#43987b')}
      </div>
    );
  }

  getStatusRetrieval() {
    return (
      <div className='wrapper_right_form_product normal_border_bottom'>
        {view_util.getSwitchView(this, 'is_delivery', 'Kirim Ke Toko', '#43987b')}
        {view_util.getSwitchView(this, 'is_take_away', 'Bawa Pulang', '#43987b')}
      </div>
    );
  }

  handleDataProductFee(){
    if(!this.state.category.selected.key){
      alert("harap pilih category terlebih dahulu");
      return;
    };

    if(this.state.information.presentase_lpi_fee < 0 || this.state.information.presentase_lpi_fee > 100){
      alert("Harap isikan nilai persen 0 - 100 atau 0 jika tidak ingin di gunakan");
      return;
    };

    if((this.state.information.amount_lpi_fee !== 0 && (this.state.information.amount_lpi_fee < 0))){
      alert("Harap isikan nilai nominal lebih dari 0 atau 0 jika tidak ingin di gunakan");
      return;
    };

    if(this.state.information.presentase_lpi_fee === this.state.information.amount_lpi_fee){
      alert("Mohon isi nilai sesuai dengan tipe fee yang dipilih / pilih tipe fee yang ingin digunakan");
      return;
    };

    let presentase_lpi_fee = this.state.information.presentase_lpi_fee;
    let is_active = this.state.information.is_active;
    let amount_lpi_fee = this.state.information.amount_lpi_fee;
    let category = this.state.category.selected;

    if(presentase_lpi_fee > 0 && amount_lpi_fee > 0){
 
      this.setState({
          is_error : true,
          body_error : {
            is_show : true,
            error_message : "Mohon pilih salah satu jenis nilai (Persentase atau Nominal)"
          }
      });

      return this.showErrorDialog(this.state.body_error)
    }

    let currentData = {
      presentase_lpi_fee,
      amount_lpi_fee,
      is_active,
      category
    }

    let data = this.upsertProductFee(this.state.product_fee,currentData);

    this.setState(prevState => ({
      information: {
        ...prevState.information,
        is_active: true,
        presentase_lpi_fee:0,
        amount_lpi_fee:0,
      },
      category:{
        ...prevState.category,
        selected:{
            key:null,
            label:'Pilih Kategori'
        }
      },
      product_fee:data,
      product_fee_dialog:{is_show:false}
    }), () => {
      this.setState({product_fee_dialog:{is_show:true}})
    });
   
  }

  upsertProductFee(arr, data) {
    const index = arr.findIndex(
      item => item.category.label === data.category.label
    );

    if (index !== -1) {
      // replace
      arr[index] = data;
    } else {
      // insert
      arr.push(data);
    }

    return arr;
  }

  handleSwitchProductFee(data){
    this.setState(prevState => ({
      product_fee:prevState.product_fee.map(item =>
        item.category.label === data.category.label
          ? { ...item, is_active: !item.is_active || false }
          : item
      ),
      product_fee_dialog:{is_show:false}
    }), () => {
      this.setState({product_fee_dialog:{is_show:true}})
    });
  }

  handlePercentageChange(data,value){
    if(!value || value < 0 || value > 100){
      alert("Harap isikan nilai persen 0 - 100 atau 0 jika tidak ingin di gunakan");
      this.setState({fee:0})
      this.setState({information:{...this.state.information,presentase_lpi_fee:0}})
      return;
    };
    this.setState({fee:value})
    this.setState({information:{...this.state.information,presentase_lpi_fee:value}})
  }

  handleNominalChange(data,value){
    if(!value || value < 0){
      alert("Harap isikan nilai nominal lebih dari 0 atau 0 jika tidak ingin di gunakan");
      this.setState({fee:0})
      this.setState({information:{...this.state.information, amount_lpi_fee:0}});
      return;
    };
     this.setState({fee:value})
     this.setState({information:{...this.state.information,amount_lpi_fee:value}})
  }

  handleEditProductFee(data){
    let params = this.state.information;
    if(params.presentase_lpi_fee > 0 && params.amount_lpi_fee > 0){
      return alert("Pilih salah satu antara persen atau nominal untuk fee produk yang digunakan")
    }

    if(params.presentase_lpi_fee < 0 || params.presentase_lpi_fee > 100){
      return alert("Harap isikan nilai persen 0 - 100 atau 0 jika tidak ingin di gunakan")
    }

    if(params.amount_lpi_fee < 0 ){
      return alert("Harap isikan nilai nominal lebih dari 0 atau 0 jika tidak ingin di gunakan")
    }

    this.setState(prevState => ({
      information:{
        ...prevState.information,
        presentase_lpi_fee: data.presentase_lpi_fee,
        amount_lpi_fee:data.amount_lpi_fee
      },
      product_fee:prevState.product_fee.map(item =>
        item.category.label === data.category.label
          ? { ...item,
            presentase_lpi_fee : prevState.information.presentase_lpi_fee,
            amount_lpi_fee : prevState.information.amount_lpi_fee,
            is_edit: !item.is_edit
          }
          : item
      ),
      product_fee_dialog:{is_show:false}
    }), () => {
      this.setState({product_fee_dialog:{is_show:true}})
    });
  }

  handleDeleteProductFee(data){

    let newProductFee = this.state.product_fee.filter(x => x.category.label !== data.category.label);
    newProductFee = newProductFee.map(i => {
      return {...i,
        presentase_lpi_fee : i.presentase_lpi_fee,
        amount_lpi_fee : i.amount_lpi_fee,
      }
    });

    this.setState(prevState => ({
      product_fee:newProductFee,
      product_fee_dialog:{is_show:false}
    }), () => {
      this.setState({product_fee_dialog:{is_show:true}})
    });
  }

  selectOption(data){
    if(!this.state.category.selected.key){
      alert("harap pilih category terlebih dahulu");
      document.getElementById('nominal').checked = false;
      document.getElementById('persen').checked = false;
      return;
    }

    this.setState({fee:0});
    if(data === 'nominal' && document.getElementById('nominal').checked === true){
      this.setState({information:{...this.state.information,option:'nominal'}});
      document.getElementById('persen').checked = false;
      if(this.state.fee){
        this.setState({information:{...this.state.information,amount_lpi_fee:this.state.fee,presentase_lpi_fee:0}})
      }
    }else if(data === 'persen' && document.getElementById('persen').checked === true){
      this.setState({information:{...this.state.information,option:'persen'}});
      document.getElementById('nominal').checked = false;
      if(this.state.fee){
        this.setState({information:{...this.state.information,presentase_lpi_fee:this.state.fee,amount_lpi_fee:0}})
      }
    }else{
      this.setState({information:{...this.state.information,presentase_lpi_fee:0,amount_lpi_fee:0}})
    }
  }

  insertProductFee(data){
    
    if(this.state.information.option){
      if(this.state.information.option === 'nominal'){
        this.handleNominalChange([],data);
      }else if(this.state.information.option === 'persen'){
        this.handlePercentageChange([],data);
      }
    }else{
      this.setState({fee:0})
      return alert("Harap pilih salah satu pilihan fee produk terlebih dahulu");
    }

  }

  changeAllSwitch(data){
    this.setState(prevState => ({
      switch : !prevState.switch,
      product_fee:prevState.product_fee.map(item =>{
        return {...item,is_active : data}
      }
      ),
      product_fee_dialog:{is_show:false}
    }), () => {
      this.setState({product_fee_dialog:{is_show:true}})
    });
  }


  popUpProductPrice(){
    return (
      <div className='process_dialog_root layer_a'>
                <div className='product_dialog_container layer_b'>
                    <div className='wrapper_form_product normal_padding_bottom default_text_medium_gray bold_text normal_border_bottom'>
                        Product Fee
                    </div>
                    <div className='vertical_margin'>
                        <div style={{display:'flex'}}>
                          <div style={{width:'55%'}}>
                            {view_util.getDropdownView(this, 'category', icon_category, 'Kategori', false, true, true)}
                          </div>
                          <div style={{width:'25%',display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                            <div>
                                  <input type='checkbox' id='persen' onChange={()=>this.selectOption('persen')}/>
                                 
                                  <label>Percentage</label>
                            </div>
                            <div>
                                  <input type='checkbox' id='nominal' onChange={()=>this.selectOption('nominal')}/>
                               
                                  <label>Value</label>
                            </div>
                            <div className="wrapper_right_form_product normal_border_bottom">
                              <input
                                placeholder='Ex. 100'
                                onChange={(e) => this.insertProductFee(e.target.value)}
                                spellCheck="false"
                                className="normal_margin_top_d bold_text default_text_normal_gray transparent_input_c"
                                type='number'
                                value={Number(this.state.fee) ? Number(this.state.fee) : 0}
                                disabled={this.state.category.selected.key === null}
                              />
                            </div>
                          </div>
                          <div style={{width:'20%',display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                              <div className="wrapper_right_form_product ">
                                <div className="custom_padding_h">
                                <div  onClick={()=>this.handleDataProductFee()} className='default_button label_search_container vertical_padding' style={{cursor:'pointer'}}>
                                  <button  className='' style={{cursor:'pointer',color:'white', backgroundColor:'#DB09AA', border:'1px #DB09AA', borderRadius:'5px', fontSize:'28px', paddingLeft:'10px', paddingRight:'10px'}}>
                                    +
                                  </button>
                                </div>
                                </div>
                              </div>
                              <div style={{display:'flex', justifyContent:'center'}}>
                                <Switch
                                  onChange={(e) => this.changeAllSwitch(e)}
                                  className="react-switch"
                                  checked={this.state.switch}
                                  height={20}
                                  width={40}
                                  onColor='#43987b'
                                />
                              </div>
                          </div>
                        </div>
                        {/* {view_util.getInputPercentView(this, 'presentase_lpi_fee', icon_coins, icon_coins, 'Presentase Fee', 'ex. 3', false, true, false,'number')}
                        {view_util.getInputView(this, 'amount_lpi_fee', icon_coins, 'Nominal Fee', 'ex. 100', false, true, false,'number')}
                        {view_util.getSwitchWrapper(icon_lightbulb, 'Status Aktif', false, this.getStatusActiveFee())} */}
                        
                        {/* <div className="wrapper_form_product normal_border_bottom normal_padding_bottom">
                          <div className="wrapper_left_form_product">
                            {/* <img className="normal_margin_top_d mini_image_d" src={icon} alt="" /> 
                            <div className="normal_margin_left default_text_normal_gray"></div>
                          </div>
                          <div className="wrapper_right_form_product normal_border_bottom">
                            <div className="custom_padding_h">
                            <div onClick={()=>this.handleDataProductFee()} className='default_button label_search_container green_background vertical_padding'>
                              <div className='normal_padding_left_c default_text_normal_white'>Add</div>
                            </div>
                            </div>
                          </div>
                        </div> */}
                        
                    </div>
                    <div className='wrapper_form_product center_content_b normal_border_bottom normal_padding_bottom'>
                        <table className='table_data_product_fee vertical_margin'>
                            <thead className=''>
                                <tr>
                                  <th className='whole_padding default_text_normal_gray'>
                                        Active
                                    </th>
                                    <th className='whole_padding default_text_normal_gray'>
                                        Category
                                    </th>
                                    <th className='whole_padding default_text_normal_gray'>
                                        Presentase Fee
                                    </th>
                                    <th className='whole_padding default_text_normal_gray'>
                                        Amount Fee
                                    </th>
                                    <th className='whole_padding default_text_normal_gray'>
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                              {this.state.product_fee.length > 0 ? 
                                this.state.product_fee.map((i,idx)=>
                                  <tr key={idx}>
                                      <td className='whole_padding default_text_normal_gray'>
                                          <div style={{display:'flex', justifyContent:'center'}}>
                                            <Switch
                                              onChange={() => { this.handleSwitchProductFee(i) }}
                                              checked={i.is_active}
                                              className="react-switch"
                                              height={20}
                                              width={40}
                                              onColor='#43987b'
                                            />
                                          </div>
                                      </td>
                                      <td className='whole_padding default_text_normal_gray'>
                                          {i.category.label}
                                      </td>
                                      <td className='whole_padding default_text_normal_gray'>
                                          {!i.is_edit ? i.presentase_lpi_fee : (<><input onChange={ (e) => this.handlePercentageChange(i,e.target.value) } value={this.state.information.presentase_lpi_fee} spellCheck='false' className='default_text_normal_gray transparent_input_d normal_border_bottom' type='number' /><img className='normal_padding_left_c mini_image_d' src={percent} alt=''/></>)}
                                      </td>
                                      <td className='whole_padding default_text_normal_gray'>
                                          {!i.is_edit ? i.amount_lpi_fee : (<><input onChange={ (e) => this.handleNominalChange(i,e.target.value) } value={this.state.information.amount_lpi_fee} spellCheck='false' className='default_text_normal_gray transparent_input_d normal_border_bottom' type='number' /><img className='normal_padding_left_c mini_image_d' src={img_edit_black} alt=''/></>)}
                                      </td>
                                      <td className=' default_text_normal_gray'>
                                          <div className='' style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                                            <div onClick={()=>this.handleEditProductFee(i)} className={`side_margin_b custom_padding_b label_search_container default_text_normal_white_b ${!i.is_edit ?'blue_background':'green_background'} process_button_b`}>
                                              <img className='normal_padding_left_c mini_image_d' src={img_edit} alt=''/>
                                             <div className='normal_padding_left_c default_text_normal_white process_button_h'>{!i.is_edit ? 'Ubah':'Simpan'}</div>
                                            </div>
                                          </div>
                                      </td>
                                  </tr>
                                )
                              : ''}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <div style={{paddingTop : 50}} className='wrapper_form_product'>
                          <div onClick={()=>this.setState({product_fee_dialog:{is_show:false}})} className='default_text_normal_white_b green_background process_button_b'>Simpan</div>
                          <div style={{width : 20}}/>
                          <div onClick={()=>{this.setState({product_fee_dialog:{is_show:false}});this.getDetailWholesaler()}} className='default_text_normal_white_b red_background process_button_b'>Tutup</div>
                        </div>
                    </div>
                </div>
            </div>
    )
  }

  onSelectedImage(event) {
    
    const files = event.target.files;
 
    if (!files || files.length === 0) {
      return;
    }
    this.setState({ image : event.target.files[0] });
  }

  initMainView() {
    if (this.state.is_main_loading) {
      return (
        <div onClick={(e) => e.stopPropagation()} className='pop_up_dialog_container'>
          <img className='big_image' src={gif_img} alt='' />
          <div className='custom_padding_c default_text_big_gray'>Memuat Data</div>
        </div>
      );
    } else {
      if (this.state.is_error) {
        return (
          <div onClick={(e) => e.stopPropagation()} className='pop_up_dialog_container'>
            <img className='normal_margin_top_c big_image_b' src={img_error} alt='' />
            <div className='whole_padding_c default_text_medium_gray'>{this.state.error_message}</div>
          </div>
        );
      } else {
        return (
          <div onClick={(e) => e.stopPropagation()} className='product_dialog_container'>
            <LoadingDialog showDialog={this.state.is_loading}/>
            {this.state.product_fee_dialog.is_show ? this.popUpProductPrice() : ''}
            {this.showErrorDialog(this.state.body_error)}
            <div className='wrapper_form_product normal_padding_bottom default_text_medium_gray bold_text normal_border_bottom'>Manajemen Grosir</div>
            {view_util.getInputView(this, 'wholesaler_id', icon_barcode, 'Kode Grosir', 'ex. G00001', true, (this.state.information.wholesaler_id !== ''), false)}
            {view_util.getInputView(this, 'reference_code', icon_barcode, 'Kode Referensi', 'ex. 123456 (Max. 6 Karakter)', false, true, false)}
            {view_util.getInputView(this, 'wholesaler_name', icon_font, 'Nama Grosir', 'ex. Grosir Daan Mogot', false, true, false)}
            {view_util.getInputView(this, 'address', icon_address, 'Alamat Grosir', 'ex. Jl. Daan Mogot KM. 18', false, true, false)}
            {view_util.getInputView(this, 'sub_district_name', icon_address, 'Area Kecamatan', 'Boleh dikosongkan', true, (this.state.information.wholesaler_id !== ''), false)}
            {view_util.getInputView(this, 'phone', icon_phone, 'Nomor Kontak', 'ex. 0812345689', false, true, false)}
            <div className='wrapper_form_product normal_border_bottom normal_padding_bottom'>
              <div className='wrapper_left_form_product'>
                <img className='normal_margin_top_d mini_image_d' src={icon_media} alt=''/>
                <div className='normal_margin_left default_text_normal_gray'>Gambar Grosir</div>
              </div>
              <div className='wrapper_right_form_product'>
                <input className='default_text_normal_gray' accept='image/x-png,image/jpeg' onChange={(event) => this.onSelectedImage(event) } type='file'/>
              </div>
            </div>
            {view_util.getDropdownView(this, 'type_wholesaler', icon_category, 'Tipe Grosir', false, true, true)}
            {view_util.getDropdownView(this, 'wholesaler_type', icon_category, 'Jenis Grosir', false, true, true)}
            {view_util.getDropdownView(this, 'status_wholesaler', icon_category, 'Status Grosir', true, true, true)}
            {view_util.getInputView(this, 'delivery_price', icon_coins, 'Biaya Layanan Aplikasi', 'ex. 10000', false, true, false)}
            {view_util.getInputView(this, 'delivery_platform', icon_coins, 'Biaya Dibebankan', 'ex. 10000', false, true, false)}
            {view_util.getInputView(this, 'is_wheeler_exist', icon_wheeler, 'Jumlah Three Wheeler', 'Min. 0', false, true, true)}
            {view_util.getSwitchWrapper(icon_lightbulb, 'Status Grosir', false, this.getStatusWholesaler())}
            {view_util.getSwitchWrapper(icon_lightbulb, 'Point Loyalty', false, this.getStatusLoyalty())}
            {view_util.getSwitchWrapper(icon_lightbulb, 'Metode Pengambilan', false, this.getStatusRetrieval())}
            {view_util.getSwitchWrapper(icon_lightbulb, 'Approval Bayar Nanti', false, this.getNeedApprovalASMForReleaseLK())}
            {view_util.getSwitchWrapper(icon_lightbulb, 'Jatuh Tempo BN', false, this.getStatusJatuhTempoBN())}
            {view_util.getSwitchBundle(this, 'payment', icon_coins, 'Metode Pembayaran', true)}
            {this.state.category && this.state.category.data && this.state.category.data.length > 0 ? view_util.getButtonWrapper(icon_lightbulb, 'Product Fee', false, this.getProductFee()) : null}
            <div style={{paddingTop : 50}} className='wrapper_form_product'>
              <div onClick={this.onPostAction.bind(this)} className='default_text_normal_white_b green_background process_button_b'>Simpan</div>
              <div style={{width : 20}}/>
              <div onClick={this.props.onCloseListener.bind(this)} className='default_text_normal_white_b red_background process_button_b'>Tutup</div>
            </div>
          </div>
        );
      }
    }
  }

  onPostAction() {
    this.setState({
      is_loading : true
    }, () => {
      try {
        if (this.state.information.wholesaler_name.length === 0) {
          throw Error('Form nama grosir masih kosong');
        }
        // if (this.state.information.reference_code.length !== 6 || Number.isNaN(Number(this.state.information.reference_code))) {
        //   throw Error('Form kode referensi grosir harus memuat 6 karakter angka');
        // }
        if (this.state.information.address.length === 0) {
          throw Error('Form alamat grosir masih kosong');
        }
        if (this.state.information.phone.length === 0) {
          throw Error('Form nomor kontak grosir masih kosong');
        }
        if (this.state.wholesaler_type.selected.key === null) {
          throw Error('Anda belum memilih jenis grosir manapun');
        }
        if (this.state.type_wholesaler.selected.key === null) {
          throw Error('Anda belum memilih tipe grosir manapun');
        }
        if (this.state.status_wholesaler.selected.key === null) {
          throw Error('Anda belum memilih status grosir manapun');
        }
        if (this.state.information.delivery_price.length === 0 || Number.isNaN(Number(this.state.information.delivery_price))) {
          throw Error('Form Biaya Layanan Aplikasi masih kosong dan harus berupa angka');
        } else if (Number(this.state.information.delivery_price) < 0) {
          throw Error('Form Biaya Layanan Aplikasi tidak boleh minus');
        }
        if (this.state.information.delivery_platform.length === 0 || Number.isNaN(Number(this.state.information.delivery_platform))) {
          throw Error('Form biaya dibebankan masih kosong dan harus berupa angka');
        } else if (Number(this.state.information.delivery_platform) < 0) {
          throw Error('Form biaya dibebankan tidak boleh minus');
        }
        if (this.state.information.is_wheeler_exist.length === 0 || Number.isNaN(Number(this.state.information.is_wheeler_exist))) {
          throw Error('Form jumlah three wheeler masih kosong dan harus berupa angka');
        } else if (Number(this.state.information.is_wheeler_exist) < 0) {
          throw Error('Form jumlah three wheeler tidak boleh minus');
        }
        if (this.state.image === null && this.state.information.wholesaler_id.length === 0) {
          throw Error('Anda belum mengupload gambar !!');
        } else if (this.state.image !== null) {
          if (!img_utils.accepted_file.includes(this.state.image.type)) {
            throw Error('Data gambar yang anda inputkan bukan berjenis jpeg/png, cobalah periksa kembali.');
          }
        }
        // CREATE FORM
        let data_form = new FormData();
        if (this.state.information.wholesaler_id !== '') {
          data_form.append('wholesaler_id', this.state.information.wholesaler_id);
        }
        if (this.state.information.img_path !== '') {
          data_form.append('img_path', this.state.information.img_path);
        }

        let price_fee = [];
       
        if(this.state.product_fee.length > 0) {
          
          for(let i of this.state.product_fee){
            price_fee.push({
              presentase_fee :i.presentase_lpi_fee,
              amount_fee :i.amount_lpi_fee,
              is_active:i.is_active || false,
              category :{
                id :i.category.key,
                label :i.category.label
              }
            });
          };
          
        }

        data_form.append('wholesaler_name', this.state.information.wholesaler_name);
        data_form.append('reference_code', this.state.information.reference_code);
        data_form.append('address', this.state.information.address);
        data_form.append('phone', str_util.parseHandphone(this.state.information.phone));
        data_form.append('delivery_price', this.state.information.delivery_price);
        data_form.append('delivery_platform', this.state.information.delivery_platform);
        data_form.append('is_open', this.state.information.is_open);
        data_form.append('open_loyalty_mayora', this.state.information.open_loyalty_mayora);
        data_form.append('is_active', this.state.information.is_active);
        data_form.append('is_delivery', (this.state.information.is_delivery ? '1' : ''));
        data_form.append('is_take_away', (this.state.information.is_take_away ? '2' : ''));
        data_form.append('payment', JSON.stringify(this.state.payment));
        data_form.append('is_wheeler_exist', this.state.information.is_wheeler_exist);
        data_form.append('synergy_status', this.state.wholesaler_type.selected.key);
        data_form.append('type_wholesaler', this.state.type_wholesaler.selected.key);
        data_form.append('status_go', this.state.status_wholesaler.selected.key);
        data_form.append('is_approval', this.state.information.is_approval);
        data_form.append('is_jatuh_tempo_extended_7_days', this.state.information.is_jatuh_tempo_extended_7_days);
        data_form.append('product_fee', JSON.stringify(price_fee));
        if (this.state.image !== null) {
          data_form.append('image_type', this.state.image.type.split('/')[1]);
          data_form.append('image', this.state.image);
        }
        this.postWholesaler(data_form);
      } catch (e) {
        this.setState({
          is_loading : false,
          body_error : {
            is_show : true,
            message : e.message
          }
        });
      }
    });
  }

  postWholesaler(body) {
    request.onRequestForm(1, '/post/wholesaler', body, function(res_data) {
      if (res_data.code === 1) {
        this.setState({
          is_loading : false
        }, () => {
          this.props.onCloseListener();
        });
      } else {
        this.setState({
          is_loading : false,
          body_error : {
            is_show : true,
            message : res_data.message
          }
        });
      }
    }.bind(this));
  }

  showErrorDialog(body) {
    if (body.is_show) {
      return <ErrorDialog body_error={body} onCloseDialog={() => this.setState({ body_error : { is_show : false, message : '' } })}/>
    } else { return null; }
  }

  showPriceFeeDialog(body) {
    if (body.is_show) {
      return( <PriceFeeDialog data={this.state.product_fee} onCloseListener={() => this.onCloseAdminWholesaler()} /> );
    } else { return null; }
  }

  render() {
    return(
      <div onClick={this.props.onCloseListener.bind(this)} className='process_dialog_root layer_a'>
        {this.initMainView()}
      </div>
    );
  }

}
